__turbopack_context__.v({
  "buttonsRow": "jc9SPq_buttonsRow",
  "closeModalWrapper": "jc9SPq_closeModalWrapper",
  "infoBox": "jc9SPq_infoBox",
  "modalContent": "jc9SPq_modalContent",
  "reasonLabel": "jc9SPq_reasonLabel",
  "reasonWrapper": "jc9SPq_reasonWrapper",
  "selectAllTitle": "jc9SPq_selectAllTitle",
  "selectAllWrapper": "jc9SPq_selectAllWrapper",
  "trigger": "jc9SPq_trigger",
});
